export default {
  club_name: 'Lillestrøm SK',
  club_name_short: 'lillestromsk',
  stadium_name: '',
  staging_url: 'https://lillestromsk.api.fangroup.io',
  prod_url: 'https://lillestromsk.api.fangroup.io',
  api: '/api',
  facebook: '',
  basename: '/lillestromsk',
  club_logo: '/assets/teams/lillestromsk.png',
  app_name: 'lillestromsk',
  websale_name: 'lillestromsk',
  ntb_team_id: 10070,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'NOK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'lillestromsk',
  monolithEnabled: false,
  clubWebsiteEnabled: false,
};
